import React from "react";
import { Check } from "lucide-react";

const STAGES = [
  { key: "paid", label: "Paid", tsKey: "created_at" },
  { key: "packed", label: "Packed", tsKey: "packed_at" },
  { key: "shipped", label: "Shipped", tsKey: "shipped_at" },
  { key: "delivered", label: "Delivered", tsKey: "delivered_at" },
];

const fmt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return ""; }
};

export default function OrderTimeline({ order }) {
  let current = 0;
  if (order.delivered) current = 3;
  else if (order.shipped) current = 2;
  else if (order.packed) current = 1;
  else if (order.status === "paid" || order.status === "shipped" || order.status === "delivered") current = 0;

  return (
    <div className="flex items-start w-full mt-4" data-testid="order-timeline">
      {STAGES.map((s, i) => {
        const reached = i <= current;
        const isLast = i === STAGES.length - 1;
        const ts = reached ? fmt(order[s.tsKey]) : "";
        return (
          <React.Fragment key={s.key}>
            <div className="flex flex-col items-center gap-1 flex-shrink-0 w-16 sm:w-24">
              <div
                className={`w-9 h-9 border-[3px] border-[#1A1A1A] flex items-center justify-center font-display ${
                  reached ? "bg-orange text-white" : "bg-white"
                }`}
                style={{ boxShadow: reached ? "3px 3px 0 0 #1A1A1A" : "none" }}
                data-testid={`stage-${s.key}`}
              >
                {reached ? <Check size={18} strokeWidth={3} /> : i + 1}
              </div>
              <span className={`text-[11px] font-bold uppercase tracking-wider ${reached ? "" : "opacity-50"}`}>{s.label}</span>
              {ts && <span className="text-[10px] opacity-70 leading-tight text-center" data-testid={`stage-${s.key}-ts`}>{ts}</span>}
            </div>
            {!isLast && (
              <div className={`flex-1 h-1 mx-1 ${i < current ? "bg-orange" : "bg-[#1A1A1A]/20"}`} style={{ marginTop: 18 }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
